export default __webpack_public_path__ + "static/media/satis.174d492d.png";